import React, { useContext as useContextCore } from 'react'
import { useSearchParams } from 'react-router-dom'

export type ProviderProps = {
  children: React.ReactNode
}

export type ContextType = {
  redirectUrl: string
} & Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const Provider = ({ children }) => {
  const [searchParams] = useSearchParams()
  const redirectUrl = searchParams.get('redirect_url') ?? ''
  return <CoreProvider value={{ redirectUrl }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
